import { ComponentType } from 'react';

const registry = new Map<string, ComponentType<any>>();

export function registerComponent(name: string, component: ComponentType<any>) {
  registry.set(name, component);
}

export function getComponent(name: string): ComponentType<any> | undefined {
  return registry.get(name);
}

export function useComponent(name: string): ComponentType<any> {
  const component = registry.get(name);
  if (!component) {
    throw new Error(`Component "${name}" not found in registry`);
  }
  return component;
}

export function clearRegisteredComponents() {
  registry.clear();
}
